import { useLocation } from 'react-router';

import { useKeyedState } from '#/hooks/useKeyedState';
import type { CmsApiPage } from '#/modules/cms/api/types/CmsApiPage';
import { isClientHydrated } from '#/rendering/state/renderingState';

export function useReloadIfFreeCodeBlockAndClientNavigation(
  content: CmsApiPage,
) {
  const location = useLocation();
  const [isClientNavigation] = useKeyedState(isClientHydrated(), {
    key: location.pathname,
  });

  // FREE_CODE blocks with <script> tags won't be properly executed in
  // dynamically loaded pages due to browser security restrictions, so we need
  // to reload the page in that case. Previous discussion:
  // https://idealist.slack.com/archives/CHJ9JK7TP/p1730383641821849
  const needsToReload =
    isClientNavigation &&
    'contentBlocks' in content &&
    content.contentBlocks?.some((block) => block.type === 'FREE_CODE');

  if (needsToReload) {
    window.location.reload();
  }

  return { showPageNotFound: needsToReload };
}
